import React from 'react';
import styled from 'styled-components';
import { Spinner } from 'src/components/spinner';
import { animations } from 'src/components/base/';

const FadeIn = styled.div`
  animation: ${animations.fadeInKeyframes} 0.5s ease-out 1.5s 1 normal forwards;
  opacity: 0;
`;

const Loader = props => (
  <FadeIn>
    <Spinner {...props} />
  </FadeIn>
);

export default Loader;
